import { render, staticRenderFns } from "./DashboardFontePagadora.vue?vue&type=template&id=731c35d1&scoped=true"
import script from "./DashboardFontePagadora.vue?vue&type=script&lang=ts"
export * from "./DashboardFontePagadora.vue?vue&type=script&lang=ts"
import style0 from "./DashboardFontePagadora.vue?vue&type=style&index=0&id=731c35d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731c35d1",
  null
  
)

export default component.exports